import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { packagePageData } from "../../UTIL/localstorageauth/PagesData/Data";

const Package = () => {
  return (
    <>
      <Box
        mt={["-20px","-20px","-20px","-70px"]}
        w="100%"
        mx="auto"
        bg="url('./img/vishal/pack.png')"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height={{ base: "200px", md: "400px", lg: "600px" }}
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        flexDirection={"column"}
      >
        <Text
          mt={["30px","30px","30px","60px"]}
          fontSize={{ sm: "15px", md: "25px", lg: "50px", xl: "50px" }}
          lineHeight={{ sm: "25px", md: "40px", lg: "55px", xl: "55px" }}
          color={"#F2CD5B"}
          textAlign="center"
          fontWeight={"700"}
        >
          <span
                    style={{
                      fontFamily: "Playfair Display",
                    }}
                  > “ Set Sail On Your Dream Vacation.”</span>
        </Text>
        {/* <Text
          textAlign="center"
          fontSize={{ sm: "15px", md: "25px", lg: "35px", xl: "60px" }}
          lineHeight={{ sm: "25px", md: "40px", lg: "50px", xl: "100px" }}
          color={"#FFFFFF"}
          fontWeight={"700"}
        >
          Promotions and Packages
        </Text> */}
      </Box>

      <SimpleGrid
        columns={[1, 1, 1, 2]}
        gap={6}
        w="90%"
        m={"auto"}
        my="20px"
        borderBottom={"2px solid #000000"}
        pb="25px"
  
      >
        {packagePageData?.map((item) => (
          <Stack
            borderWidth="1px"
            m={"auto"}
            borderRadius="lg"
            w={{ sm: "100%", md: "540px" }}
            height={{ sm: "476px", md: "20rem" }}
            direction={{ base: "column", md: "row" }}
            // bg={useColorModeValue("white", "gray.900")}
            // boxShadow={"2xl"}
            padding={4}
            data-aos="fade-right"
          >
            <Flex flex={1} bg="blue.200">
              <Image
                objectFit="cover"
                boxSize="100%"
                src={item.img}
                alt={item.alt}
              />
            </Flex>
            <Stack
              flex={1}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              p={1}
              pt={2}
            >
              <Heading fontSize={"2xl"} fontFamily={"body"} noOfLines={1}>
                {item.text}
              </Heading>
              <Text fontWeight={600} color={"gray.500"} size="sm" mb={4}>
                {item.start}
              </Text>
              <Text
                textAlign={"center"}
                // color={useColorModeValue("gray.700", "gray.400")}
                px={3}
                noOfLines={3}
              >
                {item.desc}
              </Text>
              <Stack
                width={"100%"}
                mt={"2rem"}
                direction={"row"}
                padding={2}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Link to="/allpackages">
                  <Button
                    fontFamily="700"
                    fontSize={"18px"}
                    textTransform={"capitalize"}
                    flex={1}
                    backgroundColor={"#081839"}
                    color={"white"}
                    boxShadow={
                      "0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)"
                    }
                    _hover={{
                      backgroundColor: "#081839",
                    }}
                    _focus={{
                      backgroundColor: "#081839",
                    }}
                  >
                    Book package
                  </Button>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        ))}
      </SimpleGrid>

      <Box w="90%" mx={"auto"} textAlign="center" mb="50px">
        <Text fontFamily="bold" fontSize={"22px"}>
          All prices are subject to 10% Service Charge + GSTat the prevailing
          rate.
        </Text>
      </Box>
    </>
  );
};

export default Package;